import React from 'react';
import { Box, Typography, Card, CardContent } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { CheckCircle } from '@material-ui/icons';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

const useStyles = makeStyles(() =>
  createStyles({
    successCard: {
      textAlign: 'center',
      padding: '24px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    successIcon: {
      fontSize: '40px',
      color: '#4caf50',
      marginBottom: '12px',
    },
  })
);

interface RefereeCheckCompletedProps {
  volunteerName: string;
}

export function RefereeCheckCompleted({ volunteerName }: RefereeCheckCompletedProps) {
  const classes = useStyles();
  const { theme } = useCampfireTheme();

  return (
    <Box p={2}>
      <Card className={classes.successCard}>
        <CardContent>
          <CheckCircle className={classes.successIcon} />

          <Typography
            variant='h5'
            gutterBottom
            style={{ fontWeight: 600, color: theme.color.grey.neutral400, marginBottom: '8px' }}
          >
            Reference Submitted Successfully
          </Typography>

          <Typography variant='body1' gutterBottom style={{ color: theme.color.grey.neutral400, marginBottom: '16px' }}>
            Thank you for providing a reference for <strong>{volunteerName}</strong>
          </Typography>

          <Typography variant='body2' color='textSecondary'>
            You may now close this window. Thank you for supporting {volunteerName} in their volunteer application.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
